import clsx from 'clsx'

type Props = {
	children: React.ReactNode
	variant?: 'primary' | 'secondary'
	className?: string
}

export default function Eyebrow({ children, variant = 'primary', className }: Props) {
	return (
		<p
			className={clsx(
				'eyebrow uppercase',
				variant === 'primary' ? 'text-contrast before:bg-blue' : 'text-white before:bg-white',
				className
			)}
		>
			{children}
		</p>
	)
}
